var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 17
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#B1BECF",
  d: "M6.019 4.598a.52.52 0 0 1 .715-.06l.051.046 3.183 3.235c.208.211.22.553.037.78l-.046.05-3.183 3.09a.523.523 0 0 1-.766-.032.59.59 0 0 1-.016-.754l.047-.052 2.76-2.682-2.769-2.815a.59.59 0 0 1-.057-.752z"
})));
export default SvgIconChevronRight;